import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { DropdownIcon } from "app/icons";
import React, { UIEvent } from "react";

import { ModelFieldConfig } from "../../hooks/useAddModelModal";
import { ModelFormDropDownKey } from "../../types";
import { useStyles } from "./styles";

type Props = {
  field: ModelFieldConfig;
  value: string;
  fieldLabel: (label: string) => string;
  placeholder: (label: string) => string;
  onChange: (value: string) => void;
  onMenuScroll: (
    dropDownKey: ModelFormDropDownKey | undefined,
  ) => (event: UIEvent<HTMLElement>) => void;
};

const AddModelField = ({
  field,
  value,
  fieldLabel,
  placeholder,
  onChange,
  onMenuScroll,
}: Props) => {
  const styles = useStyles();
  const { key, label, type, options = [], dropDownKey, inputType } = field;
  const isSelect = type === "select";
  const isNumber = inputType === "number";

  return (
    <Box className={styles.field}>
      <Typography className={styles.label}>{fieldLabel(label)}</Typography>
      <TextField
        className={styles.input}
        fullWidth
        select={isSelect}
        variant="outlined"
        placeholder={placeholder(label)}
        value={value}
        InputProps={{ notched: false }}
        {...(isNumber ? { inputMode: "numeric" as const } : {})}
        {...(isSelect
          ? {
              SelectProps: {
                displayEmpty: true,
                IconComponent: DropdownIcon,
                MenuProps: {
                  disableScrollLock: true,
                  PaperProps: {
                    className: styles.selectMenuPaper,
                    onScroll: onMenuScroll(dropDownKey),
                  },
                  MenuListProps: {
                    className: styles.selectMenuList,
                    onScroll: onMenuScroll(dropDownKey),
                  },
                },
                renderValue: (selected) => {
                  const selectedValue = String(selected || "");
                  if (!selectedValue) {
                    return (
                      <span className={styles.placeholder}>
                        {placeholder(label)}
                      </span>
                    );
                  }
                  const option = options.find(
                    (item) => item.value === selectedValue,
                  );
                  return option?.label || selectedValue;
                },
              },
            }
          : {})}
        onChange={(e) => onChange(e.target.value)}
      >
        {isSelect
          ? [
              <MenuItem
                key={`${key}-empty`}
                value=""
                disabled
                className={styles.selectMenuItem}
              >
                {placeholder(label)}
              </MenuItem>,
              ...options.map((opt) => (
                <MenuItem
                  key={`${key}-${opt.value}`}
                  value={opt.value}
                  className={styles.selectMenuItem}
                >
                  {opt.label}
                </MenuItem>
              )),
            ]
          : null}
      </TextField>
    </Box>
  );
};

export default AddModelField;
